import type { AlertTypes } from "commonComponents/btWrappers/BTAlert/BTAlert";

export const MFA_NUDGE_COPY = {
    PRE_THRESHOLD: {
        title: "Added protection for your account",
        body: "Because of your role, you'll be required to set up two-factor authentication (2FA) in {days} days.",
        moreInfoLabel: "Learn more",
        ctaLabel: "Enroll now",
    },
    NEAR_THRESHOLD: {
        title: "Action needed soon: Add an extra verification method",
        body: "You'll be required to set up two-factor authentication (2FA) in {days} days to keep your account secure. Set it up now to avoid interruption later.",
        moreInfoLabel: "Learn more",
        ctaLabel: "Enroll now",
    },
} as const;

export const MFA_NUDGE_NEAR_THRESHOLD_DAYS = 5;

export interface IMfaNudgeTier {
    alertType: AlertTypes;
    title: string;
    body: string;
    ctaLabel: string;
    moreInfoLabel: string;
}

function replaceDaysPlaceholder(template: string, days: number): string {
    let result = template.replace("{days}", String(days));
    if (days === 1) {
        result = result.replace("days", "day");
    }
    return result;
}

export function getMfaNudgeTierMeta(graceDaysRemaining: number): IMfaNudgeTier {
    if (graceDaysRemaining <= MFA_NUDGE_NEAR_THRESHOLD_DAYS) {
        return {
            alertType: "warning",
            ...MFA_NUDGE_COPY.NEAR_THRESHOLD,
            body: replaceDaysPlaceholder(MFA_NUDGE_COPY.NEAR_THRESHOLD.body, graceDaysRemaining),
        };
    }
    return {
        alertType: "info",
        ...MFA_NUDGE_COPY.PRE_THRESHOLD,
        body: replaceDaysPlaceholder(MFA_NUDGE_COPY.PRE_THRESHOLD.body, graceDaysRemaining),
    };
}
